<header class="emptyHeaderMain"></header>
<div class="container">
  <img src="/assets/images/verify-email.svg" alt />
  <br />
  <h1>Email Verification</h1>
  <ng-container *ngIf="status === 'Verifying'">
    Verifying your email address, please wait ...
  </ng-container>
  <ng-container *ngIf="status === 'Verified'">
    Your email was successfully verified!
    <br />
    You can now login using your WeDaVinci credentials.
    <br />
    <br />
    <button class="btn btn-primary btn-lg" routerLink="/login">Login</button>
  </ng-container>
  <ng-container *ngIf="status === 'NotVerified'">
    Could not verify your email address.
  </ng-container>
  <br />
  <br />
  <br />
</div>
